var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"height"}},[(_vm.show)?_c('div',{attrs:{"id":"suggestions"}},[_c('ul',_vm._l((_vm.suggestions),function(item,index){return _c('li',{key:index,class:{focus: index===_vm.focusIndex},on:{"click":_vm.selectItem,"mouseover":function($event){_vm.focusIndex=index}}},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0e8890","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suggestions.vue
// module id = 26
// module chunks = 0